import { estimatedPackages } from '@/components/po-estimated-package-facts-model'

function packageMeasurement(value: unknown): string | null {
  const number = Number(value)
  if (!Number.isFinite(number) || number <= 0) return null
  return number.toLocaleString('en-US', { maximumFractionDigits: 1 })
}

export function POEstimatedPackageFacts({ facts }: { facts: Record<string, unknown> }) {
  const estimate = estimatedPackages(facts)
  if (!estimate) return null
  const { packages, packageCount } = estimate

  const dimensions = new Set(
    packages.flatMap((item) => {
      const length = packageMeasurement(item.length_in)
      const width = packageMeasurement(item.width_in)
      const height = packageMeasurement(item.height_in)
      return length && width && height ? [`${length} × ${width} × ${height} in`] : []
    }),
  )
  const totalWeight = packageMeasurement(facts.total_weight_lbs)
  const dimensionSummary = dimensions.size === 1 ? [...dimensions][0] : `${dimensions.size} package sizes`

  return (
    <p className="min-w-0 text-xs text-muted-foreground">
      <span className="tabular-nums">
        {packageCount} {packageCount === 1 ? 'package' : 'packages'}
        {dimensionSummary ? ` · ${dimensionSummary}` : ''}
        {totalWeight ? ` · ${totalWeight} lbs total` : ''}
      </span>
      {/* Every package plan here is an estimate; marked like the delivery timeline's (USA-1432). */}
      <span className="ml-1 text-xs font-normal text-muted-foreground">est.</span>
    </p>
  )
}
